import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedAdmin = localStorage.getItem('entricode_admin');
    // NOTE: tokens must NOT be removed here — api.js uses entricode_token as Bearer fallback
    // for Android browsers over HTTP where Secure cookies are not sent.
    // Tokens are only cleared on explicit logout.

    if (savedAdmin) {
      setAdmin(JSON.parse(savedAdmin));
      authAPI.me()
        .then(res => {
          setAdmin(res.data);
          localStorage.setItem('entricode_admin', JSON.stringify(res.data));
        })
        .catch(() => {
          localStorage.removeItem('entricode_admin');
          setAdmin(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const response = await authAPI.login(email, password);
    const { admin: adminData, access_token, refresh_token } = response.data;
    localStorage.setItem('entricode_admin', JSON.stringify(adminData));
    if (access_token) localStorage.setItem('entricode_token', access_token);
    if (refresh_token) localStorage.setItem('entricode_refresh_token', refresh_token);
    setAdmin(adminData);
    return adminData;
  };

  const register = async (email, password, name) => {
    const response = await authAPI.register(email, password, name);
    const { admin: adminData, access_token, refresh_token } = response.data;
    localStorage.setItem('entricode_admin', JSON.stringify(adminData));
    if (access_token) localStorage.setItem('entricode_token', access_token);
    if (refresh_token) localStorage.setItem('entricode_refresh_token', refresh_token);
    setAdmin(adminData);
    return adminData;
  };

  const logout = async () => {
    try {
      await authAPI.logout();
    } catch {}
    localStorage.removeItem('entricode_admin');
    localStorage.removeItem('entricode_token');  // Clean legacy
    localStorage.removeItem('entricode_refresh_token');  // Clean legacy
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
